import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    closeButton:{
        padding: "8px", textAlign: "right",
      },
      closeContent: {
        color: "var(--primary-main, #2196F3)",
        fontFamily: "Inter",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "24px" /* 171.429% */,
        letterSpacing: "0.4px",
        textTransform: "uppercase",
      },
}));
